module.exports = __webpack_public_path__ + "img/confirm-btn-check.5d70e7e2.svg";